import WebLogo from "./logo.svg";
import WebLogoAr from "./logo_arabic.svg";

export { WebLogo, WebLogoAr };
